import { create } from 'zustand'

const userInviteStore = create((set) => ({
  userData: {
    emails: [],
    informAboutResults: true,
    userGenericMessages: true,
    readTime: 0,
    answerTime: 0,
    deadline: '',
    emailGraded: '',
    emailPassed: '',
    emailFailed: '',
    interviewId: ''
  },
   updateUserData: (newData) =>
        set((state) => ({
            userData: { ...state.userData, ...newData },
        })),
}))

export default userInviteStore
